import React, { useState, useEffect } from "react";
import axios from "axios";
import TableOne from "../Table/TableOne"; // Import your table component
import { FaSearch } from "react-icons/fa";
import Modal from "react-modal";
import "./../style/modal.css";
import "./../style/common.css";
import "./../style/pop-up.css";
import { TextField } from "@mui/material";
import { InputAdornment } from "@mui/material";
import { IoBusinessOutline } from "react-icons/io5";
import { ToastContainer, toast } from "react-toastify";
import { CiWarning } from "react-icons/ci";

const Department = () => {
  const [department, setDepartment] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [filteredDepartments, setFilteredDepartments] = useState([]); // For search functionality
  const [errors, setErrors] = useState({}); //error show state
  const [formData, setFormData] = useState({
    department_id: "",
    department_name: "",
    department_isactive: true,
  });
  const [editMode, setEditMode] = useState(false); // Edit mode flag
  const [departments, setDepartments] = useState([]);
  // State for delete confirmation
  const [deleteDepartmentId, setDeleteDepartmentId] = useState(null);
  const [deleteDepartmentName, setDeleteDepartmentName] = useState("");
  const [showDeleteDepartmentBox, setShowDeleteDepartmentBox] = useState(false);
  const userRole = localStorage.getItem("role");

  // Open delete confirmation pop-up
  const handleDelete = (dept) => {
    setDeleteDepartmentId(dept.DepartmentId);
    setDeleteDepartmentName(dept.DepartmentName || "Unnamed Department"); // Adjust field name
    setShowDeleteDepartmentBox(true);
  };

  // Confirm deletion
  const confirmDeleteDepartment = async () => {
    if (!deleteDepartmentId) return;
    try {
      const response = await axios.delete(
        `https://aligndesk.dropyourbusiness.com/api/dept/delete/${deleteDepartmentId}`
      );
      if (response.status === 200) {
        toast.success("Department deleted successfully!");
        //Update the state correctly
        const updatedDepartments = department.filter(
          (item) => item.DepartmentId !== deleteDepartmentId
        );
        setDepartment(updatedDepartments); // Update department state
        setFilteredDepartments(updatedDepartments); // Update search results
      }
    } catch (error) {
      console.error("Error deleting department:", error);
      toast.error("An error occurred while deleting the department.");
    } finally {
      setShowDeleteDepartmentBox(false); // Close the pop-up
    }
  };

  // Cancel deletion
  const cancelDeleteDepartment = () => {
    setShowDeleteDepartmentBox(false);
  };

  // Fetch Department data from the API
  const fetchDepartment = async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        "https://aligndesk.dropyourbusiness.com/api/dept"
      );
      const deptData = response.data.department.map((dept) => ({
        DepartmentId: dept.department_id,
        DepartmentName: dept.department_name,
        DepartmentIsActive: dept.department_isactive,
      }));
      console.log("department-->", deptData);
      setDepartment(deptData);
      setFilteredDepartments(deptData); // Initialize filtered data
    } catch (error) {
      console.error("Error fetching department data:", error);
      //   toast.error("Error fetching employee data.");
    }
    setLoading(false);
  };
  useEffect(() => {
    fetchDepartment();
  }, []);

  //edit
  const handleEdit = (dept) => {
    setFormData({
      department_id: dept.DepartmentId,
      department_name: dept.DepartmentName,
      department_isactive: dept.DepartmentIsActive,
    });
    setEditMode(true); // Enable edit mode
    setIsModalOpen(true); // Open modal with pre-filled data
  };
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };
  const openModal = (deptData = null) => {
    if (deptData) {
      setFormData(deptData);
      setEditMode(true);
    } else {
      setFormData({
        department_id: "",
        department_name: "",
        department_isactive: true,
      });
      setEditMode(false);
    }
    // Reset validation errors
    setErrors({});
    setIsModalOpen(true);
  };
  const closeModal = () => {
    setIsModalOpen(false);
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    // Validate the form
    const validateForm = () => {
      const newErrors = {};
      if (!formData.department_name) {
        newErrors.department_name = "Department name is required.";
      } else if (!editMode) {
        // Only check for duplicates in add mode
        const duplicateDepartment = department.find(
          (d) =>
            d.DepartmentName.toLowerCase() ===
            formData.department_name.toLowerCase()
        );

        if (duplicateDepartment) {
          newErrors.department_name = "Department name already exists!";
        }
      }
      return newErrors;
    };
    const errors = validateForm();
    if (Object.keys(errors).length > 0) {
      setErrors(errors); // Set errors in state for display
      return; // Stop the submission
    }

    try {
      const url = editMode
        ? `https://aligndesk.dropyourbusiness.com/api/dept/update/${formData.department_id}`
        : "https://aligndesk.dropyourbusiness.com/api/dept/add";

      console.log("Submitting to URL:", url);
      const method = editMode ? "put" : "post";

      await axios({
        method,
        url,
        data: formData, // <--- This is the payload being sent to the API
      });
      toast.success(
        editMode
          ? "Department updated successfully!"
          : "Department added successfully!"
      );
      fetchDepartment(); // Refresh data
      closeModal();
      setErrors({}); // Clear errors after successful submission
    } catch (error) {
      console.error("Error submitting data:", error);
      toast.error("Company with this name and email already exists!");
    }
  };

  // Table columns
  const columns = [
    { Header: "Sr.No", accessor: (row, index) => index + 1, id: "index" },
    { Header: "Department", accessor: "DepartmentName" },
  ];
  const hasAccess = (allowedRoles) => {
    const userRole = localStorage.getItem("role");
    return allowedRoles.includes(userRole);
  };
  return (
    <div>
      <ToastContainer />
      <div
        className="page-head"
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          fontSize: "10px",
          marginLeft: "1%",
          marginRight: "2%",
        }}
      >
        <h1>
          <IoBusinessOutline /> Department
        </h1>
        {hasAccess(["admin"]) && (
          <button className="add-button" onClick={() => openModal()}>
            + Add
          </button>
        )}
      </div>

      {/* Table with Pagination */}
      {loading ? (
        <div className="loader-container">
          <div className="loader"></div>
          <p>Loading...</p>
        </div>
      ) : (
        <TableOne
          columns={columns}
          data={filteredDepartments.slice().reverse()}
          handleEdit={handleEdit}
          handleDelete={handleDelete}
          isDeleteAction={true}
          isEditAction={true}
          userRole={userRole}
        />
      )}

      {/* Delete Confirmation Modal */}
      {showDeleteDepartmentBox && (
        <div className="popup-overlay">
          <div className="popup-box">
            <div className="popup-header">
              <CiWarning /> Confirm Delete
            </div>
            <div className="popup-message">
              Are you sure you want to delete the department{" "}
              <span className="department-name">
                <strong>{deleteDepartmentName}</strong>
              </span>{" "}
              from the system?
            </div>
            <div className="popup-buttons">
              <button
                className="confirm-button"
                onClick={confirmDeleteDepartment}
              >
                Yes, Delete
              </button>
              <button
                className="cancel-button"
                onClick={cancelDeleteDepartment}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}

      <Modal
        isOpen={isModalOpen}
        onRequestClose={closeModal}
        shouldCloseOnOverlayClick={false} //other click on screen, never close form modal
        contentLabel="Department Form"
        className="add-department-modal"
        style={{
          content: {
            width: "450px",
          },
        }}
      >
        <h2>{editMode ? "Edit Department" : "Add  Department"}</h2>

        <form
          className="department-form"
          onSubmit={handleSubmit}
          style={{ width: "450px" }}
        >
          <div className="form-container">
            {/* Row 1 */}
            <div className="form-row">
              <div className="form-field">
                <TextField
                  label="Department Name"
                  name="department_name"
                  value={formData.department_name}
                  error={!!errors.department_name}
                  helperText={errors.department_name}
                  onChange={handleInputChange}
                  fullWidth
                  InputProps={{
                    startAdornment: (
                      <InputAdornment
                        position="start"
                        style={{ color: "black" }}
                      >
                        <IoBusinessOutline />
                      </InputAdornment>
                    ),
                  }}
                />
              </div>
            </div>
          </div>
          <div className="all-button-form">
            <button type="submit">{editMode ? "Edit" : "+ Add"}</button>
            <button type="button" onClick={closeModal} className="close-button">
              Cancel
            </button>
          </div>
        </form>
      </Modal>
    </div>
  );
};
export default Department;
